import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getApi } from "../../../services/api/globalApi";
import LoanCountReportFilter from "./LoanCountReportFilter";

export default function LoanCountReport() {
  const [countData, setCountData] = useState({});

  const getLoanCount = async (params) => {
    const path = "admin/reports/loanCounts";
    try {
      const response = await getApi({ path, params });
      setCountData(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getLoanCount({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getLoanCount(allFilter);
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.5,
        // ease: [0, 0.71, 0.2, 1.01]
      }}
      className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6"
    >
      <h3 className="text-gray-800 dark:text-white text-lg">گزارش تعداد وام ها</h3>
      <LoanCountReportFilter filterDataHandler={filterDataHandler} />
      <div className="flex flex-wrap gap-8 items-center justify-center mt-6">
        <div className="py-8 bg-purple-600 rounded-xl w-64 text-white text-lg flex flex-col gap-4 items-center justify-center">
          <span>تعدا وام های واریز شده</span>
          {countData?.done}
        </div>
        <div className="py-8 bg-blue-600 rounded-xl w-64 text-white text-lg flex flex-col gap-4 items-center justify-center">
          <span>تعدا وام های رد شده</span>
          {countData?.reject}
        </div>
        <div className="py-8 bg-green-600 rounded-xl w-64 text-white text-lg flex flex-col gap-4 items-center justify-center">
          <span>تعدا وام های در حال بررسی</span>
          {countData?.pending}
        </div>
      </div>
    </motion.div>
  );
}
